<template>
    <div class="time-stamp">
        {{ getTime }}
    </div>
</template>
<script>
    export default {
        props: ['showTimeStamp'],
        computed: {
            getTime() {
                return new Date().toLocaleString('en-US', {
                    weekday: 'long',
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZoneName: 'short',
                });
            },
        },
    };
</script>
<style lang="scss">
    #lt-yantr {
        .time-stamp {
            font-size: 15px;
            position: relative;
            margin-bottom: 2em;
        }
    }
</style>
